export default __webpack_public_path__ + "static/media/ArticulatedArmImg.287be8f6.png";